import React from 'react';
import PropTypes from 'prop-types';

var I18n = require('i18n-react').default;

const propTypes = {
  selectedTab: PropTypes.string,
  setSelectedTab: PropTypes.func,
  isCallcenterMode: PropTypes.bool
};
function HomePageHeader(props) {  
    return (
    <section className="main-menu" id="sectionMenuHorizontal">
      <div className="section__outer">
        <nav className="menu-0002">
          <ul className="menu-0002__list" id="main-menu" data-tab="">
            <li className={`${props.selectedTab === 'search' && 'sel'} menu-0002__item`}>
              <a>
                <button
                  className="menu-0002__link skin-0012 page sel"
                  data-tab-item=""
                  style={{ cursor: 'pointer' }}
                  id="menu-comprar-passagens"
                  onClick={() => props.setSelectedTab('search')}>
                  {I18n.translate('home.header.quoteTickets')}
                </button>
                <div className="menu-0002__markup skin-0034" />
              </a>
            </li>
            {props.isCallcenterMode !== null && !props.isCallcenterMode && (
            <li className={`${props.selectedTab === 'login' && 'sel'} menu-0002__item`}>
              <a>
                <button
                  className="menu-0002__link skin-0012 page sel"
                  data-tab-item=""
                  style={{ cursor: 'pointer' }}
                  id="consultar-pnr"
                  onClick={() => props.setSelectedTab('login')}>
                  {I18n.translate('home.header.searchPNR')}
                </button>
                <div className="menu-0002__markup skin-0034" />
              </a>
            </li>
            )}
          </ul>
        </nav>
      </div>
    </section>
  );
}

HomePageHeader.propTypes = propTypes;

export default HomePageHeader;



// WEBPACK FOOTER //
// ./src/page/home/HomePageHeader.jsx